<div class="mon-dialog-header">
    <page-header header="{{'Pages failing check' | translate}}"
                 subHeader="&quot;{{ check.name }}&quot;">
    </page-header>
</div>

<div class="mon-dialog-body">
    <div class="card panel-monsido-card outer-t outer-l outer-r">
        <div class="card-body">
            <table-container [noResultMessage]="'Good job! No issues were found' | translate"
                             [collection]="pages"
                             (onPageChange)="onPageChange($event)"
                             (onPerPageChange)="onPageSizeChange($event)"
                             [progress]="progress">
                <table class="table table-hover table-fixed table-with-labels">
                    <thead>
                    <tr>
                        <th translate>
                            Title and URL
                        </th>
                        <th class="col-sm-4 col-md-4 col-lg-4"
                            monTableSort
                            monSortBy="priority_score"
                            [monSortDirection]="currentSort.direction"
                            [monCurrentlySortedBy]="currentSort.by"
                            (monOnSorted)="onMonTableSort($event)">
                            <span translate>Priority</span>
                        </th>
                        <th class="table-header-page-views"
                            monTableSort
                            monSortBy="hits"
                            [monSortDirection]="currentSort.direction"
                            [monCurrentlySortedBy]="currentSort.by"
                            (monOnSorted)="onMonTableSort($event)"
                            *ngIf="viewsColumIsAvailable">
                            <span translate>Views</span>
                            <span class="outer-l-smurf fas fa-question-circle"
                                  [triggers]="'focus hover'"
                                  ngbTooltip="'Total page views over the last 30 days' | translate">
                            </span>
                        </th>
                        <th class="col-sm-4 col-md-4 col-lg-6">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let page of pages">
                        <td>
                            <div class="text-ellipsis">
                                <mon-url-title
                                        *ngIf="!pageDetailsIsAvailable"
                                        [title]="page.title"
                                        [url]="page.url"
                                        [active]="false">
                                </mon-url-title>
                                <url-title-page-details
                                        *ngIf="pageDetailsIsAvailable"
                                        [target]="'page-details-section-accessibility'"
                                        [subTarget]="check.id"
                                        class="pl-2 inline-block text-ellipsis max-width"
                                        [page]="page"
                                        [title]="page.title"
                                        [url]="page.url"
                                        [active]="false">
                                </url-title-page-details>
                            </div>
                            <label-table *ngIf="showLabels"
                                         [assignedLabels]="page.labels"
                                         (getLabels)="getLabels()"
                                         [existingLabels]="labels"
                                         (onUpdateLabel)="updateLabels(page)">
                            </label-table>
                        </td>
                        <td class="text-v-middle">
                            <mon-priority class="vcenter" [priority]="page.priority_score_as_text">
                            </mon-priority>
                        </td>
                        <td *ngIf="viewsColumIsAvailable">
                            <visits [title]="page.title" [visits]="page.hits" [totalVisits]="pages.pageHits"></visits>
                        </td>
                        <td class="text-v-middle">
                            <div class="d-flex align-items-center justify-content-end flex-wrap flex-md-nowrap">
                                <table-page-details ngbTooltip="'Open page details' | translate"
                                                    [triggers]="'focus hover'"
                                                    [target]="'page-details-section-accessibility'"
                                                    [subTarget]="check.id"
                                                    [page]="page">
                                </table-page-details>
                                <mon-extension-visual-link-button class="ml-1" [page]="page" [type]="'acc'"></mon-extension-visual-link-button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </table-container>
        </div>
    </div>
</div>
